import type {
  GradeLevel,
  LearningLayer,
  LearningDimensionRatios,
  LearningStyleType,
  SkillDimension,
} from '@/types'

export interface LearningPlanSource {
  grade: GradeLevel
  layer: LearningLayer
  style: LearningStyleType
  completedLessons: string[]
  supportDimensions?: SkillDimension[]
  strongDimensions?: SkillDimension[]
  dimensionRatios?: LearningDimensionRatios
}

// Bump when the generated route contract changes so persisted plans are rebuilt.
// Keep the historical key version for old callers while routeVersion forces
// consumers to rebuild plans that do not contain the four-slot route.
const LEARNING_PLAN_KEY_VERSION = 4

/** Creates a stable identity for a generated plan's source inputs. */
export function createLearningPlanKey(source: LearningPlanSource): string {
  return JSON.stringify({
    version: LEARNING_PLAN_KEY_VERSION,
    routeVersion: 5,
    grade: source.grade,
    layer: source.layer,
    style: source.style,
    completedLessons: [...source.completedLessons].sort(),
    supportDimensions: [...(source.supportDimensions ?? [])].sort(),
    strongDimensions: [...(source.strongDimensions ?? [])].sort(),
    dimensionRatios: source.dimensionRatios ?? null,
  })
}
